import { DynamicStandaloneOptionalLink } from '@/components/OptionalLink';
import { ClassNameProvider } from '@/styles/Tag';
import { StandaloneComponent, StandaloneComponentProps } from '@/types/component';
import { ReactNode } from 'react';
import { StandaloneOptionalLinkProps } from '../OptionalLink';
import { Tag, TagProps } from './Tag';

export interface StandaloneTagProps extends StandaloneComponentProps {
  value?: ReactNode;
  link?: StandaloneOptionalLinkProps;
  options?: TagProps;
}

export const StandaloneTag: StandaloneComponent<StandaloneTagProps> = ({ value, link, options, ...props }) => {
  const $base = options || {};
  return (
    <ClassNameProvider value={$base}>
      <DynamicStandaloneOptionalLink
        content={
          <Tag {...$base} {...props}>
            {value}
          </Tag>
        }
        {...link}
      />
    </ClassNameProvider>
  );
};

export default StandaloneTag;
